import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_DOMAIN } from '../../utils/constants';
import { report_backup, report_company, report_generate, report_status } from './reportConstant';


const baseQuery = fetchBaseQuery({
    baseUrl: BASE_DOMAIN,
    prepareHeaders: (headers) => {
        console.log("Fetching API: Adding headers..."); // Debug log
        const token = localStorage.getItem('authToken');

        if (!token) {
            console.warn("No auth token found! API request may fail.");
            return headers; // Return headers without Authorization
        }

        headers.set('Authorization', `Bearer ${token}`);
        headers.set('Content-Type', 'application/json');
        return headers;
    }
});

// A wrapper function to handle token verification and 401 errors
const baseQueryWithAuth = async (args, api, extraOptions) => {
    console.log("Executing baseQueryWithAuth with args:", args); // Debugging log

    const token = localStorage.getItem('authToken');

    if (!token) {
        console.warn("No auth token available. Redirecting to login...");
        window.location.href = "/login"; // Redirect if no token is present
        return { error: { status: 401, message: "Unauthorized - No Token" } };
    }

    const result = await baseQuery(args, api, extraOptions);

    console.log("API Response:", result);

    if (result?.error?.status === 401) {
        console.log("Unauthorized! Logging out...");
        
        // Remove token from localStorage
        localStorage.removeItem('authToken');

        // Redirect to login page
        window.location.href = "/login"; // Adjust based on routing

        // Optionally, dispatch a logout action to update Redux state
        // api.dispatch(logoutAction());
    }
    return result;
};

export const reportSlice = createApi({
    reducerPath: 'reportApi', // Unique name for the slice
    baseQuery:baseQueryWithAuth,
    //   baseQuery: fetchBaseQuery({ baseUrl: BASE_DOMAIN }), // Replace with your API base URL
    endpoints: (builder) => ({
        reportcompany: builder.query({
            query: (id) => {
                return {
                    url: `${report_company}/${id}`, // Append query params to the endpoint
                    method: 'GET',
                };
            },
        }),
        updateStatus: builder.mutation({
            query: ({ id, payload }) => ({
                url: `${report_status}/${id}`, // Replace with your login endpoint
                method: 'PUT',
                body: payload,
            }),
        }),
        generateReport: builder.mutation({
            query: ( {year, reportType, groupId} ) => ({
              url: `${report_generate}?year=${year}&reportType=${reportType}&groupId=${groupId}`, // Build the endpoint URL
              method: 'GET', // Use GET for this API
            }),
          }),
          
        reportbackup: builder.mutation({
            query: ( {id} ) => ({
              url: `${report_backup}/${id}`, // Build the endpoint URL
              method: 'GET', // Use GET for this API
            }),
          }),
    })

})

export const { useReportcompanyQuery, useUpdateStatusMutation,useGenerateReportMutation,useReportbackupMutation } = reportSlice